//TODO: ideally this should be by chain
export const unsupportedSwapTokens = [
  '0x0000000000000000000000000000000000000000',
  '0x8E06ba13C03104f0C78A435C6FA0C0C33aE159d1', //cPollen
  '0x42cF42e55c89C6389FbbBA27dAeD4E6d2908ECF9', //cPollenV2
  '0x03c86e21623f25Eca0eA544890c7603B9a33E1AC', //ppaw
  '0x38e98c6cfda490966fb6fd952748221cb18e17a0', //BeraXBT Panda Token
  '0xbd6a2abc6bad35530ef589932a21e940b0d11e03', //Test Honey Panda Token
]
